module.exports = __webpack_public_path__ + "static/media/kp-cert-logo.ddb59fc4.jpeg";